<template>
    <nav class="navbar primary" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a class="navbar-item" href="/">
                <img :src="logo">
            </a>
            <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div id="navbarBasicExample" class="navbar-menu">
            <div class="navbar-start">
            </div>
            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="buttons">
                        <a class="button is-primary" @click="logout()" v-if="currentRouteName == 'Principal'">
                            <i class="mdi mdi-logout "></i> Cerrar sesión
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import logo from '../assets/logo.png'
import con from '../utils/db'
export default {
    name:"NavbarMenu",
    data:()=>({
        logo: logo
    }),
    methods: {
        async logout(){
            const resp = await con.logout();
            if(resp){
                this.$router.push('/login')
            }
        }
    },
   computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
}
</script>
<style scoped>
.navbar.primary {
  background-color: #04AFB7;
  color: #fff;
}
</style>